export function delayedContent() {
  //
  // content visible by delay
  //

  const visibleByDelay = document.querySelector('.visible-by-delay');

  if (visibleByDelay) {
    let timeout = parseInt(visibleByDelay.dataset.delaySeconds) * 1000;

    setTimeout(() => visibleByDelay.classList.remove('visible-by-delay'), timeout);
  }

  //
  // list of items visible by delay
  //

  const itemsListVisibleByDelay = document.querySelectorAll('.items-visible-by-delay');

  const showElementWithDelay = item => {
    item.querySelectorAll('.hidden-item').forEach((element, i) => {
      let timeout = parseFloat((i + 1) * item.dataset.delaySeconds) * 1000;

      setTimeout(function () {
        element.classList.remove('hidden-item');
        element.classList.add('visible-item');
      }, timeout);
    });
  }

  itemsListVisibleByDelay.length && itemsListVisibleByDelay.forEach(showElementWithDelay);

  //
  // content hide by delay
  //

  const hideByDelay = document.querySelector('.hide-by-delay');

  if (hideByDelay) {
    let timeout = parseFloat(hideByDelay.dataset.delaySeconds) * 1000;

    setTimeout(() => hideByDelay.style.display = 'none', timeout);
  }

  //
  // show by delay
  //

  const showByDelay = document.querySelector('.show-by-delay');

  if (showByDelay) {
    let timeout = parseFloat(showByDelay.dataset.delaySeconds) * 1000;

    setTimeout(() => showByDelay.classList.remove('show-by-delay'), timeout);
  }

  //
  // show by delay all
  //

  const showByDelayAll = document.querySelectorAll('.show-by-delay-all');

  if (!!showByDelayAll) {
    showByDelayAll.forEach((e) => {
      let $this = e;
      let timeout = parseFloat($this.dataset.delaySeconds) * 1000;
      setTimeout(() => $this.classList.remove('show-by-delay-all'), timeout);
    });
  }
}

//
// categories ui
//

export function categoriesScrollTop() {
  const scrollTopBtn = document.querySelector('.scroll-top-btn');

  if (!document.querySelector('.category') || !scrollTopBtn) { return; }

  document.onscroll = function() {
    if (document.documentElement.scrollTop > 100 && !scrollTopBtn.classList.contains('active')) {
      scrollTopBtn.classList.add('active');
    } else if (document.documentElement.scrollTop <= 100 && scrollTopBtn.classList.contains('active')) {
      scrollTopBtn.classList.remove('active');
    }
  };
}

//
// Redirect with delay
//

export function redirectWithDelay() {
  const redirectContainer = document.querySelector('.redirect-with-delay');

  if (redirectContainer && redirectContainer.dataset.redirectUrl.trim().length) {
    let timeout = redirectContainer.dataset.delaySeconds * 1000;

    setTimeout(() => location.href = redirectContainer.dataset.redirectUrl, timeout);
  }
}

//
// content load slow
//

export function contentLoadSlowHandler() {
  const container = document.querySelectorAll('.content-load-slow');

  if (!container.length) { return; }

  const image = document.querySelector('.game-question-image');

  image && setTimeout(() => image.style.visibility = 'visible', 1000);

  const answers = document.querySelector('.game-answers');

  answers && setTimeout(() => answers.style.visibility = 'visible', 5000);
}

//
// button with spinner option
// it's inactive until loading is not over
//

export function btnWithSpinner() {
  document.querySelectorAll('.btn.btn-with-spinner').forEach(button => {
    const spinner = button.querySelector('.btn-spinner');

    if (!spinner) { return; }

    const delay = parseInt(button.dataset.delaySeconds) * 1000;

    if (delay <= 0) {
      button.classList.remove('btn-with-spinner');
      spinner.remove();
      return;
    }

    setTimeout(() => {
      button.classList.remove('btn-with-spinner');
      spinner.remove();
    }, delay);
  });
}

export function scrollLockByDelay() {
  const scrollLockByDelay = document.querySelector('.scroll-lock');

  if (!scrollLockByDelay) { return; }

  let delay = 0;

  if (scrollLockByDelay.classList.contains('scroll-lock-delay-500')) {
    delay = 500;
  }

  if (scrollLockByDelay.classList.contains('scroll-lock-delay-1000')) {
    delay = 1000;
  }

  setTimeout(function(){
    scrollLockByDelay.classList.remove('scroll-lock')
  }, delay);
}